import validate from "/builds/egov/fms/gesundheitsberufe-iff/frontend/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/builds/egov/fms/gesundheitsberufe-iff/frontend/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "auth-guard": () => import("/builds/egov/fms/gesundheitsberufe-iff/frontend/node_modules/@interone/iff-frontend/middleware/auth-guard.ts"),
  "fee-admin-guard": () => import("/builds/egov/fms/gesundheitsberufe-iff/frontend/node_modules/@interone/iff-frontend/middleware/fee-admin-guard.ts"),
  "organisation-admin-guard": () => import("/builds/egov/fms/gesundheitsberufe-iff/frontend/node_modules/@interone/iff-frontend/middleware/organisation-admin-guard.ts"),
  "template-admin-guard": () => import("/builds/egov/fms/gesundheitsberufe-iff/frontend/node_modules/@interone/iff-frontend/middleware/template-admin-guard.ts")
}